import { Button, Flex, IconPlus, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { FieldGroupBox } from 'ui'
import { styles } from './styles'
import { messages } from './messages'

type Props = {
  name: string
  onAdd: () => void
  labeled: boolean
}

export function RegularScopeEmptyView(props: Props) {
  const { name, onAdd, labeled } = props

  return (
    <FieldGroupBox name={name}>
      <Flex direction="column" className={styles.content}>
        <Text variant="action2" hidden={!labeled}>
          <FormattedMessage {...messages.empty.description} />
        </Text>
        <Button variant="secondary" icon={<IconPlus />} onClick={onAdd}>
          <FormattedMessage {...messages.empty.add} />
        </Button>
      </Flex>
    </FieldGroupBox>
  )
}
